<template>
  <footer>
    <div class="cd_container cd_footer-container">
      <div class="cd_footer">
        <FooterAddress header="Friends of Deckers Creek" email="info@deckerscreek.org" phone="(304) 292-3970" address="205 Parsons Street, Morgantown WV 26505"/>
        <FooterSocial>
          <ul>
            <li><SocialLink icon="facebook-square" icon_color="white" title="Facebook" url="https://www.facebook.com/DeckersCreek"/></li>
            <li><SocialLink icon="instagram-square" icon_color="white" title="Instagram" url="https://www.instagram.com/fodc_wv"/></li>
            <li><SocialLink icon="twitter-square" icon_color="white" title="Twitter" url="https://twitter.com/fodc_wv"/></li>
            <li><SocialLink icon="youtube-square" icon_color="white" title="YouTube" url="https://www.youtube.com/channel/UC7GmE9fHvGYbefYRKFWiYYA"/></li>
          </ul>
        </FooterSocial>
        <FooterFeedback />
      </div>
      <FooterCopyright />
    </div>
  </footer>
</template>

<script>
  import FooterAddress from './footer-address'
  import FooterSocial from './footer-social'
  import FooterFeedback from './footer-feedback'
  import FooterCopyright from './footer-copyright'
  import SocialLink from './social-link'

  export default {
    name: 'Footer',
    components: {
      FooterAddress,
      FooterSocial,
      FooterFeedback,
      SocialLink,
      FooterCopyright
    }
  }
</script>
